import Alpine from 'alpinejs'

// Import premium signup modal component
import './components/premium-signup-modal.js'

import './components/premium-popup.js'

// Import global hash scroll handler
import './hash-scroll.js'

// Initialize Alpine
Alpine.start()